import './index.less';

import { Space, TextLabel } from '@tonic-one/react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Info, InfoProps } from '@Components/Common/Info';

export const MemoTextLabel = memo(
  (props: { label: string; textLabelStyle?: {}; required?: boolean }) => {
    const { t } = useTranslation();
    return (
      <TextLabel className="itemLabel" style={props.textLabelStyle}>
        {t(props.label)}:
        {props.required && <span className="requiredField">*</span>}
      </TextLabel>
    );
  }
);

export const MemoTextLabelWithInfo = memo(
  (props: {
    label: string;
    infoLabel: string;
    infoVariant?: InfoProps['variant'];
    textLabelStyle?: {};
    required?: boolean;
  }) => {
    const {
      label,
      infoLabel,
      infoVariant = 'outline',
      textLabelStyle,
      required,
    } = props;
    const { t } = useTranslation();
    return (
      <TextLabel className="itemLabel" style={textLabelStyle}>
        {t(label)}:{required && <span className="requiredField">*</span>}
        <Space width="2x"></Space>
        <Info content={t(infoLabel)} variant={infoVariant} />
      </TextLabel>
    );
  }
);
